export const adjustTemperature = `
vec3 adjustTemperature(vec3 color, float temperature, float temperatureRange) {
    float temperatureFactor = temperature / temperatureRange;
    color.r = clamp(color.r * (1.0 + temperatureFactor), 0.0, 1.0);
    color.b = clamp(color.b * (1.0 - temperatureFactor), 0.0, 1.0);
    return color;
  }
`;
